import { view } from "../../../views/mapView/MapView";
import Point from "@arcgis/core/geometry/Point";

export const handleScroll = (event) => {
  let element = event.currentTarget;
  element.scrollIntoView({
    scrollMode: 'if-needed',
    behavior: 'smooth',
    block: 'center'
  })
}

export const onTableRowMouseOver = (feature,layerName)=>{
  // let graphic = selectionLayer.graphics
  // .filter(
  //   (graphic) => graphic.attributes.OBJECTID === feature.attributes.OBJECTID
  // )
  // .getItemAt(0);

}

export const onTableRowClick = (view,feature, callback=zoomHighlightOpenPopupforGraphic) => {
  callback(view,feature)
};

const  zoomHighlightOpenPopupforGraphic= (view,graphic)=>{
  try {
    if(graphic?.geometry){
      const {geometry} = graphic
      let locPoint
      if(graphic.geometry.type==="polygon"){
      locPoint = new Point({
        spatialReference: graphic.geometry.spatialReference,
        x: geometry.centroid.x,
        y: geometry.centroid.y,
      });
    }
    if(graphic.geometry.type==="polyline"){
       let pathIndex =Math.floor((graphic.geometry.paths.length-1)/2)
       let pointIndex = Math.floor((geometry.paths[pathIndex].length-1)/2)
       locPoint= graphic.geometry.getPoint(pathIndex,pointIndex)
    }
    if(graphic.geometry.type==="point"){
      locPoint = new Point({
        spatialReference: graphic.geometry.spatialReference,
        x: geometry.x,
        y: geometry.y,
      });
    
    }
    if(graphic.geometry.type==="multipoint"){
      locPoint= graphic.geometry.getPoint(graphic.geometry.points[Math.floor((graphic.geometry.points.length-1)/2)])
    }
    let currentVisibility=view.popup.visible
      view.goTo({target:graphic.geometry,zoom:8});
      view.popup.open({ features: [graphic], location: locPoint });
      view.popup.visible=currentVisibility
    }else{throw "geometry not found"}
    
  } catch (error) {
    console.error(error)
    
  }



}
